import cityData from '@/assets/json/city.json'

interface Region {
    name: string
    city?: Record<string, Region>
    areas?: Record<string, Region>
}

const regions = cityData as Record<string, Region>

export const regionOptions = Object.keys(regions).map(provinceCode => ({
    label: regions[provinceCode].name,
    value: provinceCode,
    children: Object.keys(regions[provinceCode].city || {}).map(cityCode => ({
        label: regions[provinceCode].city![cityCode].name,
        value: cityCode,
        children: Object.keys(regions[provinceCode].city![cityCode].areas || {}).map(districtCode => ({
            label: regions[provinceCode].city![cityCode].areas![districtCode].name,
            value: districtCode,
        })),
    })),
}))

export const getRegionNames = (codes: Array<string | number | undefined | null>): string[] => {
    const [provinceCode, cityCode, districtCode] = codes.map(code => String(code || ''))
    const province = regions[provinceCode]
    const city = province?.city?.[cityCode]
    const district = city?.areas?.[districtCode]

    return [province?.name, city?.name, district?.name].filter((name): name is string => !!name)
}

export const getRegionCodesByNames = (provinceName: string, cityName: string, districtName: string): string[] => {
    const provinceCode = Object.keys(regions).find(code => regions[code].name === provinceName)
    const province = provinceCode ? regions[provinceCode] : undefined
    const cityCode = Object.keys(province?.city || {}).find(code => province!.city![code].name === cityName)
    const city = cityCode ? province?.city?.[cityCode] : undefined
    const districtCode = Object.keys(city?.areas || {}).find(code => city!.areas![code].name === districtName)

    return provinceCode && cityCode && districtCode ? [provinceCode, cityCode, districtCode] : []
}
